/**
 * React Static Boilerplate
 * https://github.com/kriasoft/react-static-boilerplate
 *
 * Copyright © 2015-present Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */

import React from 'react';
import Header from './Header';
import s from './Layout.css';

class Layout extends React.Component {

  componentDidMount() {
    // window.componentHandler.upgradeElement(this.refs.root);
  }

  componentWillUnmount() {
    // window.componentHandler.downgradeElements(this.refs.root);
  }

  render() {
    return (
      <div ref="root" className={s.wrapper}>
        <Header />
        <main {...this.props} className={s.content} />
      </div>
    );
  }
}

export default Layout;



/** WEBPACK FOOTER **
 ** ./components/Layout/Layout.js
 **/